import GameCardCarousel from '@/components/features/common/GameCardCarousel';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { Box } from '@mui/material';
import { gameListSelector } from '@/state/globalSettings';
import { useAtomValue } from 'jotai';

export default function GameRecommended() {
  const { t } = useTranslation();

  const { list } = useAtomValue(gameListSelector);

  const { route, ...rest } = useRouter();
  // const games = () => {
  //   const crash = {
  //     name: 'Crash',
  //     gameId: 'moonClub_crash',
  //     category: 'MoonClub Game',
  //     startUrl: '/casino/crash',
  //   };
  //   const rush = {
  //     name: 'Moon Rush',
  //     gameId: 'moonClub_rush',
  //     category: 'MoonClub Game',
  //     startUrl: '/casino/rush',
  //   };
  //   if (route.includes('crash')) {
  //     return [rush];
  //   } else if (route.includes('rush')) {
  //     return [crash];
  //   } else {
  //     return [crash, rush];
  //   }
  // };
  return (
    <Box
      sx={{
        mt: 2,
      }}
    >
      <GameCardCarousel
        title={t('Recommended')}
        games={list.filter((game) => {
          return game.provider === 'SELF' && !route.includes(game.gameId);
        })}
      />
    </Box>
  );
}
